import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CrmFeatureGuard } from './crm/crm-feature-guard';
import { MasterAdminGuard } from './shared/guards/master-admin.guard';


const routes: Routes = [
  {
    path: 'utilities/styleguide',
    loadChildren: 'app/styleguide/styleguide.module#StyleguideModule'
  },

  {
    path: 'utilities/styleguide',
    loadChildren: 'app/styleguide/styleguide.module#StyleguideModule'
  },
  {
    path: 'utilities',
    loadChildren: 'app/utilities/utilities.module#UtilitiesModule'
  },
  {
    path: 'vendor',
    loadChildren: 'app/vendor/vendor.module#VendorModule'
  },
  {
    path: 'records',
    loadChildren: 'app/records/records.module#RecordsModule'
  },
  {
    path: 'tokens',
    loadChildren: 'app/tokens/tokens.module#TokensModule'
  },
  {
    path: 'questions',
    loadChildren: 'app/question-bank/question-bank.module#QuestionBankModule'
  },
  {
    path: 'communications',
    loadChildren: 'app/communications/communications.module#CommunicationsModule'
  },
  {
    path: 'manage-training',
    loadChildren: 'app/manage/manage.module#ManageModule'
  },
  {
    path: 'documents',
    loadChildren: 'app/documents/documents.module#DocumentsModule'
  },
  {
    path: 'content',
    loadChildren: 'app/content/content.module#ContentModule'
  },
  {
    path: 'store',
    loadChildren: 'app/store/store.module#StoreModule'
  },

  {
    path: 'design-system',
    loadChildren: 'app/design-system/design-system.module#DesignSystemModule'
  },
  {
    path: 'settings',
    loadChildren: 'app/settings/settings.module#SettingsModule'
  },
  {
    path: 'curriculum',
    loadChildren: 'app/curriculum/curriculum.module#CurriculumModule'
  },
  {
    path: 'safety-reports',
    loadChildren: 'app/safety-reports/safety-reports.module#SafetyReportsModule'
  },
  {
    path: 'help',
    loadChildren: 'app/help/help.module#HelpModule'
  },
  {
    path: 'auth',
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  {
    path: 'new-login',
    loadChildren: 'app/login/login.module#LoginModule'
  },
  {
    path: 'subjects',
    loadChildren: 'app/subjects/subjects.module#SubjectsModule'
  },
  {
    path: 'home',
    loadChildren: 'app/home/home.module#HomeModule'
  },  {
    path: 'legal',
    loadChildren: 'app/legal/legal.module#LegalModule'
  },
  {
    path: 'api',
    loadChildren: 'app/api/api.module#ApiModule'
  },
  {
    path: 'competencies',
    loadChildren: 'app/competencies/competencies.module#CompetenciesModule'
  },
  {
    path: 'users',
    loadChildren: 'app/users/users.module#UsersModule'
  },
  {
    path: 'express-module',
    loadChildren: 'app/express-module/express-module.module#ExpressModuleModule'
  },
  {
    path: 'qualifications',
    loadChildren: 'app/qualifications/qualifications.module#QualificationsModule'
  },
  {
    path: 'instructor',
    loadChildren: 'app/instructor/instructor.module#InstructorModule'
  },
  {
    path: 'master-admin',
    loadChildren: 'app/master-admin/master-admin.module#MasterAdminModule',
    canActivate: [MasterAdminGuard]
  },
  {
    path: 'master_admin',
    redirectTo: 'master-admin',
    pathMatch: 'prefix'
  },
  {
    path: 'training',
    loadChildren: 'app/training/training.module#TrainingModule'
  },
  {
    path: 'knowledgebases',
    loadChildren: 'app/knowledgebases/knowledgebases.module#KnowledgebasesModule'
  },
  {
    path: 'ai-chat',
    loadChildren: 'app/ai-chat/ai-chat.module#AiChatModule'
  },
  {
    path: 'ai-usage',
    loadChildren: 'app/ai-usage/ai-usage.module#AiUsageModule'
  },
  {
    path: 'checklists',
    loadChildren: 'app/checklists/checklist.module#ChecklistModule'
  },
  {
    path: 'crm',
    canActivate: [CrmFeatureGuard],
    loadChildren: 'app/crm/crm.module#CrmModule'
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  // {
  //   path: '**',
  //   component: PageNotFoundComponent
  // }
  // {
  //   path: 'utilities/testing',
  //   loadChildren: 'app/newtest/newtest.module#NewtestModule'
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'} )
  ],
  exports: [RouterModule],
  providers: []
})

export class AppRoutingModule { }
